import { Fragment } from 'react';
import {
  groceriesFilters,
  recipesFilters,
  searchToolFilters,
  searchToolGroceriesFilters,
  isFoodsPage,
} from '../const';
import { hasAppliedFilters } from '../../utils/utils';

const FilterPill = (props) => {
  const {
    appliedFilters,
    toggleFunc,
    applyFunc,
    getFunc,
    isRecipe,
    appliedSearchText,
    updateTextFunc,
    isCustomize,
    tagOptions,
  } = props;

  // override the protein options which in this case cannot be hardcoded like the others:
  groceriesFilters['protein']['options'] = tagOptions;
  recipesFilters['protein']['options'] = tagOptions;
  searchToolGroceriesFilters['protein']['options'] = tagOptions;
  searchToolFilters['protein']['options'] = tagOptions;

  const appliedOrNot = hasAppliedFilters(appliedFilters);
  if (!appliedOrNot && !appliedSearchText) {
    return <Fragment></Fragment>;
  }

  const clearFilter = (filter, filterCategory) => {
    toggleFunc(filter, filterCategory);
    applyFunc();
    getFunc();
  };

  const clearSearch = () => {
    updateTextFunc('');
    getFunc();
  };

  const makePillElement = (filterName, filterCategory) => {
    if (filterName == null || !filterCategory) {
      return;
    }
    let currentFilterOptions;
    if (!isCustomize) {
      const filterObj = isFoodsPage
        ? searchToolGroceriesFilters
        : searchToolFilters;
      currentFilterOptions = filterObj[filterCategory]['options'][filterName];
    } else {
      currentFilterOptions = isRecipe
        ? recipesFilters[filterCategory]['options'][filterName]
        : groceriesFilters[filterCategory]['options'][filterName];
    }

    if (!currentFilterOptions) return;
    let name = currentFilterOptions['optionText'];

    return (
      <div
        key={`${filterName}-${filterCategory}`}
        className={'filter-pill'}
        onClick={() => clearFilter(filterName, filterCategory)}
      >
        <span className="filter-name">{name}</span>
        &nbsp;
        <div className={'filter-pill-x'}>×</div>
      </div>
    );
  };

  const renderPills = () => {
    let elementList = [];
    for (let key in appliedFilters) {
      if (Array.isArray(appliedFilters[key])) {
        appliedFilters[key].forEach((filterName) =>
          elementList.push(makePillElement(filterName, key))
        );
      } else {
        elementList.push(makePillElement(appliedFilters[key], key));
      }
    }
    return elementList;
  };

  const renderSearchText = () => {
    if (appliedSearchText) {
      return (
        <div className="applied-search-text" data-testid="applied-search-text">
          Results for&nbsp;
          <div className="search-pill" onClick={clearSearch}>
            <span className="hr_font_book_italic search-text-display">
              {appliedSearchText}
            </span>
            &nbsp;
            <span
              data-testid="applied-search-text-clear"
              className="clear-search-x"
            >
              ×
            </span>
          </div>
        </div>
      );
    }
  };

  return (
    <Fragment>
      {appliedOrNot ? (
        <div className={'pills-container'}>{renderPills()}</div>
      ) : null}
      {renderSearchText()}
    </Fragment>
  );
};

export default FilterPill;
